import React from "react";
import "./Reviews.css";
import rev_img1 from "../../assets/images/Lp/rev-1.png";
import rev_img2 from "../../assets/images/Lp/rev-2.png";
import quote_img from "../../assets/images/Lp/quote.png";

const Box_data = [
  {
    id: 1,
    name: "Catalyst Pet",
    role: "Chief Executive Officer",
    saved: "$478 saved in first Month",
    rev_img: rev_img1,

    desc: "We had some customers who would just order a massive amount on their first order, just to take advantage of our first time customer discount. It turns out, those people were making multiple email addresses, and then ordering even more on the next order! What’s more, some of those people would even file chargebacks after, costing us even more money. It would turn into such a headache, and a lot of those people would also abuse our customer service staff. With CustomerGenius, we can fire our worst customers, and allow ourselves to focus on our best ones.",
  },
  {
    id: 2,
    name: "Bear Mountain",
    role: "Digital Marketing Manager",
    saved: "$142 saved in first month",
    rev_img: rev_img2,

    desc: "We were looking for a solution to crack down on discount abuse – it was costing us hundreds each month. CustomerGenius has been incredibly easy to use – it’s set it and forget it. We were honestly shocked by two numbers – just how many people were abusing the system, and how many of those people, when caught, purchased at full price! CustomerGenius pays for itself several times over each month.",
  },
];
export default function Reviews({ id }) {
  return (
    <div id={id} className="section py-constant bg-light">
      <div className="container">
        <div className="subtitle">Testimonials</div>

        <h2 className="h2    title center">
          Hear from other users
          <span className="accent"> of CustomerGenius!</span>
        </h2>
        <div className="flex flex-row rev-inner">
          {Box_data.map((item) => {
            return (
              <div className="rev-box">
                <img src={quote_img} width={50} alt="" className="quote " />

                <span className="badge">{item.saved}</span>

                <div className="text-md">{item.desc}</div>

                <div className="rev-bottom">
                  <div className="detail">
                    <span className="name">{item.name}</span>
                    <span className="role">{item.role}</span>
                  </div>

                  <img src={item.rev_img} width={60} alt="" className="image" />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
